<script setup>
import { computed } from 'vue';
import {
  SEMANTIC_ACTION_CLASSES,
  SEMANTIC_COLOR,
  SEMANTIC_SURFACE_CLASSES,
  isSemanticColor,
} from 'dashboard/components-next/semanticColors';

const props = defineProps({
  color: {
    type: String,
    default: SEMANTIC_COLOR.NEUTRAL,
    validator: isSemanticColor,
  },
  actionLabel: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['action']);

// Warning/danger banners should interrupt the user (role="alert"); the
// rest are background status updates the user can catch up on when they
// pause (role="status"). Both are implicit live regions, so screen readers
// announce these without any explicit aria-live wiring.
const liveRegionRole = computed(() =>
  [SEMANTIC_COLOR.DANGER, SEMANTIC_COLOR.WARNING].includes(props.color)
    ? 'alert'
    : 'status'
);

const bannerClass = computed(() => SEMANTIC_SURFACE_CLASSES[props.color]);
const buttonClass = computed(() => SEMANTIC_ACTION_CLASSES[props.color]);

const triggerAction = () => {
  emit('action');
};
</script>

<template>
  <div
    :role="liveRegionRole"
    aria-atomic="true"
    class="text-sm rounded-xl flex items-center justify-between gap-2 border"
    :class="[
      bannerClass,
      {
        'py-2 px-3': !actionLabel,
        'pl-3 p-2': actionLabel,
      },
    ]"
  >
    <div>
      <slot />
    </div>
    <div>
      <button
        v-if="actionLabel"
        type="button"
        class="px-3 py-1 w-auto grid place-content-center rounded-lg"
        :class="buttonClass"
        @click="triggerAction"
      >
        {{ actionLabel }}
      </button>
    </div>
  </div>
</template>
